import { DataListWrapper, ServiceResponse } from 'loca-boot-core'
import {
  ResourceItemModel,
  ResourceListModel,
} from '@/pages/chargermap/components/iconRender/icon.model'
import {
  ChargerOrderCountModel,
  SummaryModel,
} from '@/pages/chargermap/components/informationComps/information/information.model'
import { RouteModelDetail } from '@/pages/chargermap/components/recommendRender/recommend.model'
import { SearchModel } from '@/pages/chargermap/components/searchList/searchList.model'
import { memoryCache } from '@/utils/cache'
import { fetch } from '@/utils/fetch'
import { NewStationListModel, TimeDimList } from '../components/newStation/newStation.model'
import { ConfigItem, Point } from '../contract/map'
import { BannerItem } from '../models/config.model'
import { RouteCDNModel, ShareModelLink } from '../models/detail.model'
import { LocationModel } from '../models/location.model'
import { OutletsModel } from '../models/outlets.model'
import { EnergyPlanNewDataModel } from '../models/plan.model'
import { RecommendModel } from '../models/recommend.model'
import { WishPowerSummaryModel } from '../models/summary.model'
import { useAppStore } from '../stores/app'
declare global {
  interface Window {
    getPowerAroundTimestamp: number
  }
}
/**
 * 获取资源数据概览
 * https://apidoc.nioint.com/project/10079/interface/api/922888
 */
export function getSummary(
  area_code?: string,
  longitude?: number,
  latitude?: number,
  type?: string
) {
  return fetch.get('charge-map/v2/power/around/summary', {
    params: { area_code, longitude, latitude, type },
    wrapper: SummaryModel,
  })
}

/**
 * 获取服务中心资源数据概览
 * 通用接口地图基本指标查询
 * https://apidoc.nioint.com/project/10079/interface/api/1234281
 */
export function getIndicatorSummary(
  indicators?: string[],
  map_channel?: string,
  dim_code = 'region_code',
  dim_value = '000000'
) {
  return fetch.get('charge-map/v1/indicator/basic/summary', {
    params: { indicators: (indicators || []).join(','), map_channel, dim_code, dim_value },
  })
}

// let curLocation: Loc | null = null
// /**
//  * 设置当前的定位
//  */
// export function setLocation(location: Loc) {
//   curLocation = location
// }

/**
 * 根据关键字搜索资源
 * http://showdoc.nevint.com/index.php?s=/702&page_id=33361
 * @param {string} city 搜索城市。area_code或者城市名。如110100或北京市
 * @param {string} keywords 搜索关键词
 */
export function getSuggest(city: string | null, keywords: string) {
  return fetch.post('charge-map/v1/power/suggest', {
    params: { city, keywords },
  })
}

/**
 * 首页根据关键字搜索资源
 * https://apidoc.nioint.com/project/10079/interface/api/1110316
 * @param {string} city 搜索城市。area_code或者城市名。如110100或北京市
 * @param {string} keywords 搜索关键词
 * @param {string} types 搜索大类
 */
export function getSuggestHomeFn(city: string, keywords: string, types?: string) {
  return fetch.post(`charge-map/v2/around/keywords/search?types=${types || ''}`, {
    params: { city, keywords, types },
    wrapper: SearchModel,
  })
}
export const getSuggestHome = memoryCache(getSuggestHomeFn)
// export const getSuggestHome = getSuggestHomeFn

export function getPowerAroundV2Fn(
  level: number,
  filter_request: object,
  loc?: Point,
  distance?: number
) {
  const map_level = Math.floor(level) // 整数
  const latitude = loc?.lat
  const longitude = loc?.lng
  const url = `charge-map/v2/around?map_level=${map_level}&latitude=${latitude}&longitude=${longitude}&distance=${distance}`
  const params = {
    filter_request,
    user_id: window.iframeParams?.userId,
    vehicle_id: window.iframeParams?.vehicleId,
  }
  return fetch.post(url, {
    params,
    wrapper: ResourceListModel,
  })
}

// export const getPowerAroundV2 = memoryCache(getPowerAroundV2Fn)
export const getPowerAroundV2 = getPowerAroundV2Fn // TODO 实时换电状态

/**
 * 获取桩群详情
 * http://showdoc.nevint.com/index.php?s=/702&page_id=34114
 * @param {string} id 桩群id
 */
export function getChargeStationDetail(id: string, longitude?: string, latitude?: string) {
  const params = { group_id: id } as { [key: string]: any }
  longitude && (params['longitude'] = longitude)
  latitude && (params['latitude'] = latitude)
  // 20240109 v1接口改为v2接口，去掉location字段
  return fetch.get('charge-map/v2/charge-station/detail', {
    params,
    wrapper: ResourceItemModel,
  })
}

/**
 * 获取换电站详情
 * http://showdoc.nevint.com/index.php?s=/702&page_id=34115
 * @param {string} id 换电站id
 */
export function getPowerSwapDetail(id: string, longitude?: string, latitude?: string) {
  const params = { swap_id: id } as { [key: string]: any }
  longitude && (params['longitude'] = longitude)
  latitude && (params['latitude'] = latitude)
  // 20240109 v1接口改为v2接口，去掉location字段
  return fetch.get('charge-map/v2/power-swap/detail', {
    params,
    wrapper: ResourceItemModel,
  })
}

/**
 * 获取线路详情
 * http://showdoc.nevint.com/index.php?s=/702&page_id=34116
 * @param {string} id 路线id
 */
export const getChargingTripRoute = memoryCache(function getChargingTripRoute(id: string) {
  return fetch.get('charge-map/v1/charging-trip/route', {
    params: { id },
    wrapper: RouteModelDetail,
  })
})

/**
 * 获取资源数据CDN地址
 * @returns
 */

export const getChargemapCDNurl = async (configs: ConfigItem[]) => {
  const appStore = useAppStore()
  return new Promise<any>((resolve) => {
    const timer = setInterval(() => {
      if (configs && configs.length) {
        const suffix = (process.config as any).dict_suffix
        const cdnUrl = new RouteCDNModel({
          chargingTripRouteLink:
            configs.filter((item) => {
              return item.key === 'h5_charging_trip_route_link' + suffix
            })[0]?.value || '',
          swapResourcesLink:
            configs
              .filter((item) => {
                return item.key === 'h5_charge_map_power_swap_resource_cdn_link' + suffix
              })[0]
              ?.value?.split(';') || [],
          chargeResourcesLink:
            configs
              .filter((item) => {
                return item.key === 'h5_charge_map_charge_station_resource_cdn_link' + suffix
              })[0]
              ?.value?.split(';') || [],
          thirdResourcesLink:
            configs
              .filter((item) => {
                return item.key === 'h5_charge_map_third_resource_cdn_link' + suffix
              })[0]
              ?.value?.split(';') || [],
          nioStoreResourcesLink:
            configs
              .filter((item) => {
                return item.key === 'h5_charge_map_nio_store_resource_cdn_link' + suffix
              })[0]
              ?.value?.split(';') || [],
          testDriveResourcesLink:
            configs
              .filter((item) => {
                return item.key === 'h5_charge_map_test_drive_resource_cdn_link' + suffix
              })[0]
              ?.value?.split(';') || [],
          serviceCenterResourcesLink:
            configs
              .filter((item) => {
                return item.key === 'h5_charge_map_service_center_resource_cdn_link' + suffix
              })[0]
              ?.value?.split(';') || [], // 服务中心
          wishPowerLink:
            configs
              .filter((item) => {
                return item.key === 'h5_wish_stations_address_cdn_link' + suffix
              })[0]
              ?.value?.split(';') || [],
        })
        clearInterval(timer)
        resolve(cdnUrl)
      } else {
        configs = appStore.dictionaries
      }
    }, 200)
  })
}

/**
 * 首页/详情页分享
 * http://showdoc.nevint.com/index.php?s=/702&page_id=34117
 * @param {string} [id] 路线id，首页分享时不传，详情分享时必传
 */
export function getChargingTripShare(id?: string) {
  return fetch.get('charge-map/v1/charging-trip/share', {
    params: { trip_id: id },
    wrapper: ShareModelLink,
  })
}

/**
 * 心愿站分享
 * https://apidoc.nioint.com/project/10079/interface/api/844035
 *
 */
export function getWishPowerShare() {
  return fetch.get('charge-map/v1/wish/station/share', {
    wrapper: ShareModelLink,
  })
}

/**
 * 心愿站地址数据
 * https://apidoc.nioint.com/project/10079/interface/api/844035
 * @param {string} [city_code] 城市code，全国传000000或者不传
 */
export function getWishPowerSummary(cityCode?: string) {
  return fetch.get('charge-map/v2/wish/station/summary', {
    params: { city_code: cityCode },
    wrapper: WishPowerSummaryModel,
  })
}

/**
 * 累计换电次数
 * https://apidoc.nioint.com/project/10079/interface/api/852335
 * @param {string} [area_code] 城市code，全国传000000或者不传
 */
export function getChargerOrderCount(params: { area_code?: string; indicator_codes?: string }) {
  return fetch.get('charge-map/v1/realtime-indicators', {
    params,
    wrapper: ChargerOrderCountModel,
  })
}

/**
 * 获取沿途补能规划
 * http://showdoc.nevint.com/index.php?s=/702&page_id=34119
 * @param {string} orig 起点，longitude,latitude GCJ02坐标系
 * @param {string} dest 终点，longitude,latitude GCJ02坐标系
 */

export function getEnergyPlanRealtime(orig: string, dest: string) {
  return fetch.post('charge-map/v1/energy-plan/multi', {
    params: { orig, dest },
    wrapper: EnergyPlanNewDataModel,
  })
}

/**
 * 获取路径规划（新）
 * https://apidoc.nioint.com/project/10079/interface/api/896680
 * @param {Point} loc 位置
 */
export function getEnergyPlanNew(
  orig: string,
  orig_poi_name: string,
  dest: string,
  dest_poi_name: any,
  avg_kilo_energy: any,
  full_battery_cap: any,
  model_type: any
) {
  return fetch.post('charge-map/v2/energy-plan/multi', {
    params: {
      orig,
      orig_poi_name,
      dest,
      dest_poi_name,
      avg_kilo_energy,
      full_battery_cap,
      model_type,
    },
    wrapper: EnergyPlanNewDataModel,
  })
}

export const getEnergyPlan = memoryCache(getEnergyPlanNew)

/**
 * 逆地址查询
 * http://showdoc.nevint.com/index.php?s=/702&page_id=34120
 * @param {Point} loc 位置
 * @param {String} tag 标签，用于记录是哪个功能调用的
 */
export const getLocation = memoryCache(function getLocation(loc: Point, tag: string) {
  const longitude = loc.lng
  const latitude = loc.lat
  if (longitude && latitude) {
    return fetch.get('charge-map/v1/rgeo', {
      params: { longitude, latitude, page_source: window.page_source, tag },
      wrapper: LocationModel,
    })
  } else {
    return Promise.resolve(new ServiceResponse())
  }
})

/**
 * 获取基本信息
 * http://showdoc.nevint.com/index.php?s=/PEOSS&page_id=5692
 * @param {id}  资源ID
 */
export function getChargeStationInfo<T>(id: string, accessToken?: string) {
  const parser = document.createElement('a')
  parser.href = (fetch.getGenFetch() as any).driver.adapter.url
  const hostname = parser.hostname.replace('pe-fe-gateway', 'powerpro-api')
  return fetch.get<T>(`https://${hostname}/pe/powerpro/pe/prime/platform/v1/devices/${id}/detail`, {
    params: { fields: 'model' },
    options: accessToken ? { headers: { Authorization: 'Bearer '.concat(accessToken) } } : {},
  })
}

/**
 * 获取banner
 * http://showdoc.nevint.com/index.php?s=/702&page_id=34115
 * @param {string} businessModule 移动端 我的定位: pe_h5_map_mobile，移动端 首页顶部:nsh5_mobile_homepage_banner，移动端首页弹窗:nsh5_mobile_homepage_reminder，pc端首页弹窗:nsh5_pc_homepage_reminder
 */
export function getBannerList(businessModule: string) {
  return fetch.get('charge-map/v1/banner', {
    params: { business_module: businessModule },
    wrapper: new DataListWrapper({ itemType: BannerItem }),
  })
}

/**
 * 未开始的运营位，预请求下载
 * https://apidoc.nioint.com/project/10079/interface/api/1048744
 * @param {string} businessModule "nsh5_mobile_homepage_reminder": "移动端首页弹窗"，"nsh5_pc_homepage_reminder": "pc端首页弹窗"
 */
export function getUnreachedBannerList(businessModule: string) {
  return fetch.get('charge-map/v1/unreached/banner', {
    params: { business_module: businessModule },
    wrapper: new DataListWrapper({ itemType: BannerItem }),
  })
}

/**
 *获取地图周边推荐列表
 * https://apidoc.nioint.com/project/10079/interface/api/1109258
 * @param {filter} 周边推荐过滤器
 *
 */
export function getRecommendFn(lng: number, lat: number, filter: any) {
  return fetch.post(`charge-map/v2/around/recommend?longitude=${lng}&latitude=${lat}`, {
    params: {
      filter_request: filter,
      user_id: window.iframeParams?.userId,
      vehicle_id: window.iframeParams?.vehicleId,
    },
    wrapper: RecommendModel,
  })
}
export const getRecommend = memoryCache(getRecommendFn)

/**
 * 获取资源详情
 * https://apidoc.nioint.com/project/10079/interface/api/1258847
 * @param {string} [code] 参数code；多个以,隔开，不传返回全部
 */
export function getOutletsDetailV2Fn(
  id: string,
  type: string,
  subType: string,
  longitude?: string,
  latitude?: string,
  outlet_name?: string
) {
  const params = {} as { [key: string]: any }
  id && (params['outlets_id'] = id)
  outlet_name && (params['outlet_name'] = outlet_name) // 特殊字符代替，数据源不一致的问题
  type && (params['type'] = type)
  subType && (params['subType'] = subType)
  longitude && (params['longitude'] = longitude)
  latitude && (params['latitude'] = latitude)
  return fetch.post(`charge-map/v2/outlets/detail`, {
    params,
    wrapper: OutletsModel,
  })
}

// export const getOutletsDetailV2 = memoryCache(getOutletsDetailV2Fn)
export const getOutletsDetailV2 = getOutletsDetailV2Fn // 去除接口数据缓存

/**
 * 查询新站上新列表
 * https://apidoc.nioint.com/project/10079/interface/api/1340424
 *
 */
export function getNewStationList(
  longitude: string | number,
  latitude: string | number,
  time_dim_code?: string
) {
  const params = {
    filter_request: { 'recharge|ps': null, 'recharge|cs': null },
  }
  const path =
    longitude && latitude
      ? `charge-map/v1/resource/new-station/detail?longitude=${longitude}&latitude=${latitude}${
          time_dim_code ? `&time_dim_code=${time_dim_code}` : ''
        }`
      : `charge-map/v1/resource/new-station/detail${
          time_dim_code ? `?time_dim_code=${time_dim_code}` : ''
        }`
  return fetch.post(path, {
    params,
    wrapper: NewStationListModel,
  })
}

/**
 * 获取新站上新时间维度筛选配置
 * https://apidoc.nioint.com/project/10079/interface/api/1439909
 */
export function getTimeDimList() {
  return fetch.get('charge-map/v1/resource/new-station/time-dims', {
    wrapper: TimeDimList,
  })
}
